module.exports = __webpack_public_path__ + "img/check-circle-fill.230ca958.svg";